import { FormItem } from '../../../../commons/Form/Form.types';
import { LoginENTFormSchema } from './LoginENTForm.types';

export const loginCommercialFormData: FormItem<LoginENTFormSchema>[][] = [
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'password',
      placeholder: 'Votre mot de passe...',
      label: 'Mot de passe',
      type: 'password',
      required: true,
    },
  ],
];
